import React from "react";
import { Link } from "react-router-dom";

const heroBackground = {
  backgroundImage: `linear-gradient(110deg, rgba(7, 28, 47, 0.88) 0%, rgba(7, 28, 47, 0.72) 42%, rgba(7, 28, 47, 0.35) 100%), url("${process.env.PUBLIC_URL}/images/Captura%20de%20pantalla%202026-03-27%20080946.png")`,
};

const Home = () => (
  <section className="container page-shell">
    <div className="hero-panel" style={heroBackground}>
      <div className="hero-copy">
        <span className="section-kicker">Gestión de muestras y casos</span>
        <h1 className="hero-title">Un flujo más claro, moderno y rápido para el laboratorio.</h1>
        <p className="hero-text">
          Centraliza ingresos, documentos y seguimiento de resultados en una interfaz simplificada y amigable.
        </p>
        <div className="hero-actions">
          <Link to="/ingreso-caso" className="btn btn-brand btn-lg">
            Crear nuevo caso
          </Link>
          <Link to="/ingreso-muestra" className="btn btn-outline-brand btn-lg">
            Cargar muestra
          </Link>
        </div>
      </div>
      <div className="hero-badge-card">
        <div className="hero-badge-card__brand">
          <img src="/logo-inta.png" alt="Logo INTA" className="hero-badge-card__logo" />
          <div className="status-pill">INTA</div>
        </div>
        <h2>Panel operativo</h2>
        <p>Formularios más claros, validaciones visibles y una identidad visual alineada a la investigación.</p>
      </div>
    </div>
  </section>
);

export default Home;
